import { createRequest, createRequestNodeRed } from '../../utils/createRequest';

export const request = createRequest();
export const requestNodeRed = createRequestNodeRed();
